import React, {useEffect} from 'react';
import {LockOutlined, UserOutlined} from '@ant-design/icons';
import {Button, Checkbox, Form, Input, message} from 'antd';
import './css/login.css';
import {useForm} from 'antd/es/form/Form';
import {aesDecrypt, aesEncrypt} from '../sandbox/common/EncodeDecodeMethod';
import {Arguments} from '../sandbox/common/Arguments';
import {getIPAddress, PostToJava} from '../sandbox/common/ApiMethod';
import {getFirstLetters} from '../sandbox/common/ConversionMethod';

export default function Login(props) {
	const [form] = useForm();

	useEffect(() => {
		getIPAddress().then(ip => sessionStorage.setItem('ip', ip));
	}, []);

	const onFinish = (loginInfo) => {
		// 将密码加密后存储在 sessionStorage 中
		const hashedPassword = aesEncrypt(loginInfo.password);
		// 首先出现滑动验证码
		onCaptchaShow(loginInfo, hashedPassword);
		// 记住我的功能
		if (loginInfo.remember) {
			localStorage.setItem('storedUser', JSON.stringify({...loginInfo, password: hashedPassword}));
		}
	};

	// 滑动验证码组件
	function onCaptchaShow(loginInfo, hashedPassword) {
		const captcha = new window.TencentCaptcha('194909226', function(res) {
			// 滑动验证码成功后的逻辑
			if (res?.ret === 0) {
				let postUserInfo = loginInfo;
				if (loginInfo.username !== 'skladmin') {
					// 将输入的汉字用户名转成首字母形式
					const charUsername = getFirstLetters(loginInfo.username);
					postUserInfo = {...loginInfo, username: charUsername};
				}
				// 首先验证当前用户是否存在（有可能是已经删除的用户）
				let userIsExisted = false;
				const getLoginUser = Arguments.host + '/society_organization/policy/api!getLoginUser.do';
				PostToJava(getLoginUser, {username: postUserInfo.username}).then(res => {
					let currentUser = {};
					if (res?.data.code === 1 && res?.data.result.data.resultList.length > 0) {
						userIsExisted = true;
						currentUser = res.data.result.data.resultList[0];
						// 获取登录用户的 organization_id 和 role 并存储在 sessionStorage 中
						sessionStorage.setItem('coffee', (parseInt(currentUser.organizationId) * 20).toString());
						sessionStorage.setItem('rain', currentUser.role);
					} else {
						message.error('接口请求异常');
					}
					return currentUser;
				}).then((currentUser) => {
					// 验证通过后再验证用户名和密码是否匹配
					if (userIsExisted) {
						// 向用户中心接口发送 post 请求，验证用户名和密码是否正确
						const loginApi = Arguments.host + '/society_organization/login/author!login.do';
						PostToJava(loginApi, postUserInfo).then(res => {
							if (res?.data.code === 1) {
								const userInfo = res.data.result;
								// console.log('userInfo       ', userInfo);
								// 方便接口 token 校验以及页面显示用户名等信息
								sessionStorage.setItem('userToken', userInfo.token);
								// 方便登录页右上角显示用户名以及修改密码时填入默认的用户名
								sessionStorage.setItem('ghost', currentUser.nickname);
								// 方便用户修改密码时使用，对密码使用对称加密保存
								sessionStorage.setItem('shadow', hashedPassword);
								// 不同用户跳转到不同页面
								if (loginInfo.username === 'skladmin') {
									props.history.push('/home');
								} else {
									props.history.push('/society/society-information');
								}
							} else {
								message.error('登录失败：' + res?.data.result.msg || '用户名或密码错误');
							}
						});
					}
				});
			}
		}, {});
		captcha.show();
	}

	const onReset = () => {
		form.resetFields();
	};
	// “记住我”的功能应该是用户输入用户名后，进行判断，如果与保存的一致，就不用输入密码了，在输入用户名之前不自动填写用户名和密码
	const checkUser = (e) => {
		const currentUser = e.target.value;
		const user = localStorage.getItem('storedUser') ? JSON.parse(localStorage.getItem('storedUser')) : null;
		if (user?.username && currentUser === user.username) {
			// 将保存的用户信息作为初始值，此时密码应该通过对称加密后解密写入输入框中，对接后续用户中心验证流程
			form.setFieldsValue({...user, password: aesDecrypt(user.password)});
		} else {
			form.setFieldsValue({username: currentUser, password: '', remember: false});
		}
	};

	return (
		<div className="backgroundContainer">
			<div className="headerContainer"/>
			<div className="formContainer">
				<Form
					style={{marginTop: 30}}
					form={form}
					name="normal_login"
					onFinish={onFinish}
				>
					<Form.Item
						name="username"
						rules={[
							{
								required: true,
								message: '请输入用户名!',
							},
						]}
					>
						<Input
							onChange={checkUser}
							size="large"
							style={{width: '70%', left: '50%', transform: 'translateX(-50%)'}}
							prefix={<UserOutlined className="site-form-item-icon"/>}
							placeholder="用户名"/>
					</Form.Item>
					<Form.Item
						name="password"
						rules={[
							{
								required: true,
								message: '请输入密码!',
							},
						]}
					>
						<Input.Password
							size="large"
							style={{width: '70%', left: '50%', transform: 'translateX(-50%)'}}
							prefix={<LockOutlined className="site-form-item-icon"/>}
							placeholder="密码"
						/>
					</Form.Item>

					<Form.Item name="remember" valuePropName="checked" style={{marginLeft: 87}}>
						<Checkbox>记住我</Checkbox>
					</Form.Item>

					<Form.Item>
						<Button type="primary" htmlType="submit" style={{marginLeft: 87}}>
							登录
						</Button>
						<Button type="default" htmlType="submit" style={{marginLeft: 20}} onClick={() => onReset()}>
							取消
						</Button>
					</Form.Item>
				</Form>
			</div>
			<div className="footerContainer">天津市社会科学界联合会社会组织部</div>
		</div>
	);
}
